export class Poll {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/poll/poll.ts